import React, { useState } from 'react';

export function FilterBar({ search, filters, actions, activeFilterCount = 0, onClearFilters }) {
    const [filtersExpanded, setFiltersExpanded] = useState(false);

    return (
        <div className="mb-4 space-y-2">
            <div className="flex flex-wrap items-center gap-2">
                {/* Search — always visible */}
                {search}

                {/* Filters — visible on desktop, behind toggle on mobile */}
                {filters && (
                    <div className="hidden sm:contents">
                        {filters}
                    </div>
                )}

                {/* Mobile filter toggle */}
                {filters && (
                    <button
                        type="button"
                        onClick={() => setFiltersExpanded(!filtersExpanded)}
                        className="sm:hidden inline-flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium rounded-lg border border-slate-200 dark:border-slate-700 bg-white dark:bg-slate-800 text-slate-600 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-700 transition-colors"
                    >
                        <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                            <path strokeLinecap="round" strokeLinejoin="round" d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
                        </svg>
                        <span>Filters</span>
                        {activeFilterCount > 0 && (
                            <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-accent-500 text-white text-xs font-bold">
                                {activeFilterCount}
                            </span>
                        )}
                    </button>
                )}

                {/* Clear filters link */}
                {activeFilterCount > 0 && onClearFilters && (
                    <button
                        type="button"
                        onClick={onClearFilters}
                        className="text-xs text-accent-500 hover:text-accent-600 font-medium hidden sm:inline transition-colors"
                    >
                        Clear filters
                    </button>
                )}

                {/* Spacer */}
                <div className="flex-1" />

                {/* Actions — always visible */}
                {actions && (
                    <div className="flex items-center gap-2">
                        {actions}
                    </div>
                )}
            </div>

            {/* Mobile expanded filters */}
            {filters && filtersExpanded && (
                <div className="sm:hidden flex flex-wrap items-center gap-2 pt-1">
                    {filters}
                    {activeFilterCount > 0 && onClearFilters && (
                        <button
                            type="button"
                            onClick={() => { onClearFilters(); setFiltersExpanded(false); }}
                            className="text-xs text-accent-500 hover:text-accent-600 font-medium transition-colors"
                        >
                            Clear filters
                        </button>
                    )}
                </div>
            )}
        </div>
    );
}
